import { postJSON } from 'common/services/api'
import dayjs from 'dayjs'
import isoWeek from 'dayjs/plugin/isoWeek'
import { useCallback } from 'react'
import { useQueryClient } from 'react-query'
import { YEAR_FIRST_DATE_FORMAT } from '../utils.datetime'
import {
  GENERATE_URL,
  REVISIONS_QUERY_KEY,
  ROTA_GENERATED_QUERY_KEY
} from './queryConstants'

dayjs.extend(isoWeek)

type UseGenerateReturn = {
  generateRota: (values: UseGeneratePayload) => Promise<unknown>
}

type UseGenerateProps = {
  startDate: string
}

type UseGeneratePayload = {
  allocationTemplateName?: string
  allocationTemplateId?: string
}

const useGenerate = ({ startDate }: UseGenerateProps): UseGenerateReturn => {
  const queryClient = useQueryClient()

  // GENERATE
  const generate = useCallback(
    async (values: UseGeneratePayload): Promise<unknown> => {
      return postJSON({
        url: `${GENERATE_URL}`,
        method: 'POST',
        isRota: true,
        json: {
          startDate: dayjs(startDate)
            .startOf('isoWeek')
            .format(YEAR_FIRST_DATE_FORMAT),
          name: values.allocationTemplateName,
          templateId: values.allocationTemplateId
        }
      })
    },
    [startDate]
  )

  const handleGenerate = useCallback(
    async (values: UseGeneratePayload) => {
      try {
        const result = await generate(values)
        queryClient.invalidateQueries([REVISIONS_QUERY_KEY])
        queryClient.invalidateQueries([ROTA_GENERATED_QUERY_KEY])
        return result
      } catch (err) {
        return err
      }
    },
    [generate, queryClient]
  )

  return {
    generateRota: handleGenerate
  }
}

export default useGenerate
